/*
  When the customer changes Frame/Color, if the currently-selected Format
  is not offered under the new frame (shows disabled), auto-select the
  first available Format instead of leaving a dead selection checked.

  This is the real fix for the "Compact XL reads as sold out" class of bug
  (Retro Finder, Ultra Violet, Siren — 2026-09) — the picker no longer
  requires the shopper to notice and manually recover from an invalid combo.

  Dawn's product-info.js replaces the whole <variant-selects> element after
  its fetch resolves (HTMLUpdateUtility.viewTransition), so this waits for
  that DOM swap via MutationObserver rather than guessing a timeout.
*/
(function () {
  if (window.__cxcAutoFormatBound) return;
  window.__cxcAutoFormatBound = true;

  function findFieldsetByKeyword(root, keywords) {
    var fieldsets = root.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      var txt = (legend ? legend.textContent : '').toLowerCase();
      for (var k = 0; k < keywords.length; k++) {
        if (txt.indexOf(keywords[k]) > -1) return fieldsets[i];
      }
    }
    return null;
  }

  function correctFormatIfNeeded(variantSelects) {
    var formatFieldset = findFieldsetByKeyword(variantSelects, ['format', 'layout']);
    if (!formatFieldset) return;
    var checked = formatFieldset.querySelector('input:checked');
    if (!checked || !checked.classList.contains('disabled')) return;
    var firstAvailable = formatFieldset.querySelector('input:not(.disabled)');
    if (!firstAvailable || firstAvailable === checked) return;
    firstAvailable.checked = true;
    firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /*
    Clicking a struck-through (unavailable) pill used to do nothing because
    CSS killed its pointer events — a dead click. Now the click is steered: find
    the available variant that has the clicked value and keeps as many of the
    shopper's other choices as possible, then select that whole combo. If no
    variant offers the value at all, fall through to a plain select so Dawn
    shows its normal unavailable/sold-out state on the buy button.
  */
  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js').then(function (r) {
        return r.json();
      });
    }
    return productCache[handle];
  }

  // warm the cache once the page is idle so a first tap on an unavailable pill isn't waiting on it
  function warmProduct() {
    var vs = document.querySelector('variant-selects');
    if (vs && vs.dataset.productHandle) getProduct(vs.dataset.productHandle).catch(function () {});
  }
  if ('requestIdleCallback' in window) window.requestIdleCallback(warmProduct, { timeout: 4000 });
  else setTimeout(warmProduct, 2000);

  function radiosByOption(root, name) {
    return Array.prototype.filter.call(root.querySelectorAll('input[type="radio"]'), function (i) {
      return i.dataset.optionName === name;
    });
  }

  function steerToAvailable(input) {
    var root = input.closest('variant-selects');
    var handle = root && root.dataset.productHandle;
    var plain = function () {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    if (!handle) return plain();
    getProduct(handle).then(function (product) {
      var names = product.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
      var idx = names.indexOf(input.dataset.optionName);
      if (idx < 0) return plain();
      var current = names.map(function (n) {
        var c = radiosByOption(root, n).filter(function (i) { return i.checked; })[0];
        return c ? c.value : null;
      });
      var best = null;
      var bestScore = -1;
      product.variants.forEach(function (v) {
        if (!v.available || v['option' + (idx + 1)] !== input.value) return;
        var score = 0;
        names.forEach(function (n, k) {
          if (k !== idx && v['option' + (k + 1)] === current[k]) score++;
        });
        if (score > bestScore) { best = v; bestScore = score; }
      });
      if (!best) return plain();
      names.forEach(function (n, k) {
        radiosByOption(root, n).forEach(function (i) {
          i.checked = i.value === best['option' + (k + 1)];
        });
      });
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }).catch(plain);
  }

  document.addEventListener('click', function (e) {
    var label = e.target.closest && e.target.closest('variant-selects .product-form__input--pill label');
    if (!label) return;
    var input = label.control;
    if (!input || input.type !== 'radio' || !input.classList.contains('disabled')) return;
    e.preventDefault();
    steerToAvailable(input);
  });

  /*
    GA4 `swatch_click` (Joi 2026-10-18, clicks-to-swatches per ad): fires on every click of a PDP swatch/pill,
    same dataLayer + gtag path as sticky_atc_click / pdp_accordion_toggle. A label click also dispatches a click on
    its radio, so a repeat on the same radio within 500ms is skipped. variant_id is the variant matching the shopper's other current
    choices plus the clicked value (empty if that combo doesn't exist); steered clicks on struck-through pills
    report the clicked value, not the combo they were steered to.
  */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var root = t.closest('variant-selects');
    if (!root) return;
    var input = null;
    if (t.tagName === 'INPUT') {
      input = t;
    } else {
      var label = t.closest('label');
      input = label && label.control;
    }
    if (!input || input.type !== 'radio' || !input.dataset.optionName) return;
    // the label click and the radio click it triggers are one shopper click
    var now = Date.now();
    if (input.__cxcSwatchAt && now - input.__cxcSwatchAt < 500) return;
    input.__cxcSwatchAt = now;

    var handle = root.dataset.productHandle;
    var params = {
      product_handle: handle,
      option_name: input.dataset.optionName,
      option_value: input.value,
      variant_id: '',
    };
    function send() {
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'swatch_click' }, params));
      if (typeof window.gtag === 'function') window.gtag('event', 'swatch_click', params);
    }
    if (!handle) return send();
    getProduct(handle).then(function (product) {
      var names = product.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
      var idx = names.indexOf(input.dataset.optionName);
      if (idx > -1) {
        var vals = names.map(function (n, k) {
          if (k === idx) return input.value;
          var c = radiosByOption(root, n).filter(function (i) { return i.checked; })[0];
          return c ? c.value : null;
        });
        var match = product.variants.filter(function (v) {
          return vals.every(function (val, k) { return v['option' + (k + 1)] === val; });
        })[0];
        if (match) params.variant_id = String(match.id);
      }
      send();
    }).catch(send);
  });

  document.addEventListener('change', function (e) {
    var target = e.target;
    var variantSelects = target.closest && target.closest('variant-selects');
    if (!variantSelects) return;

    var optionName = (target.dataset.optionName || '').toLowerCase();
    var isFrameChange = optionName.indexOf('frame') > -1 || optionName === 'color';
    if (!isFrameChange) return;

    var parent = variantSelects.parentNode;
    if (!parent) return;

    var observer = new MutationObserver(function (mutations, obs) {
      obs.disconnect();
      var newVariantSelects = parent.querySelector('variant-selects');
      if (newVariantSelects) correctFormatIfNeeded(newVariantSelects);
    });
    observer.observe(parent, { childList: true });
    // Safety timeout in case no swap happens (e.g. the combo is genuinely
    // unavailable site-wide and product-info.js takes the setUnavailable() path).
    setTimeout(function () { observer.disconnect(); }, 3000);
  });
})();
